"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyMatrix = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const product_tree_1 = require("../../client/product-tree");
const use_get_enriched_categories_hook_1 = require("../../client/product-tree-nodes/hooks/use-get-enriched-categories.hook");
const context_1 = require("../../context");
const generic_1 = require("../../generic");
const selected_l1_categories_1 = require("../../store/shared/selected-l1-categories");
const attributes_matrix_selector_container_1 = require("../components/attributes-matrix-selector/attributes-matrix-selector.container");
const display_table_select_component_1 = require("../components/display-table-select.component");
const l1_category_matrix_selector_component_1 = require("../components/l1-category-matrix-selector.component");
const strategy_matrix_skeleton_1 = require("../components/strategy-matrix-skeleton");
const matrix_table_component_1 = require("../components/table-logic/matrix-table.component");
const table_styles_1 = require("../components/table.styles");
const use_apply_query_params_for_strategy_matrix_hook_1 = require("../hooks/use-apply-query-params-for-strategy-matrix.hook");
const store_1 = require("../store");
const localization_1 = require("../../../localization");
const router_1 = require("../../../router");
const store_2 = require("../../../store");
const StrategyMatrix = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedCatalogId = (0, store_2.useSelectedCatalogId)();
    const productTreeRootNodeId = (0, store_2.useProductTreeRootNodeId)();
    const selectedProductTreeId = (0, store_2.useProductTreeId)();
    const { isReEnrichmentInProgress } = (0, context_1.useCatalogActivityProgressContext)();
    const { selectedAttributes = [], extendedFilter = [], selectedDisplayTable = [], } = (0, store_1.useStrategyMatrixData)();
    const { data: enrichedCategories, isLoading: areEnrichedCategoriesLoading, } = (0, use_get_enriched_categories_hook_1.useGetEnrichedCategories)(extendedFilter);
    const { isLoading: isCatalogProductTreeLoading, } = (0, product_tree_1.useCatalogProductTree)(selectedCatalogId, { skip: !selectedCatalogId });
    const sortedSelectedL1Categories = (0, react_1.useMemo)(() => (0, ramda_1.sortBy)((0, ramda_1.prop)('label'), enrichedCategories).map((category) => (Object.assign(Object.assign({}, category), { children: category.children ? (0, ramda_1.sortBy)((0, ramda_1.prop)('label'), category.children) : category.children }))), [enrichedCategories]);
    // TODO: add error handler
    const { isLoading: areQueryParamsLoading, isReady: areQueryParamsReady, } = (0, use_apply_query_params_for_strategy_matrix_hook_1.useApplyQueryParamsForStrategyMatrix)();
    const areMatrixPrerequisitesLoading = areQueryParamsLoading
        || !areQueryParamsReady
        || isCatalogProductTreeLoading
        || areEnrichedCategoriesLoading;
    const handleAttributesSelectionChanged = (0, react_1.useCallback)((selectedAttributeNames) => {
        dispatch((0, store_1.setSelectedDataForStrategyMatrix)(selectedCatalogId, {
            selectedAttributes: selectedAttributeNames,
        }));
    }, [dispatch, selectedCatalogId]);
    const handleCategorySelectionChanged = (0, react_1.useCallback)((selection) => {
        const selectedCategories = selection.map(selected_l1_categories_1.convertGroupedOptionToCategory);
        dispatch((0, store_1.setSelectedDataForStrategyMatrix)(selectedCatalogId, {
            extendedFilter: selectedCategories,
        }));
    }, [dispatch, selectedCatalogId]);
    const handleDisplayTableSelectionChanged = (0, react_1.useCallback)((selection) => {
        dispatch((0, store_1.setSelectedDataForStrategyMatrix)(selectedCatalogId, {
            selectedDisplayTable: selection,
        }));
    }, [dispatch, selectedCatalogId]);
    return (react_1.default.createElement(table_styles_1.StyledMatrixContainer, null, react_1.default.createElement(ui_components_1.PageTitle, { className: "title", title: t({ key: 'STRATEGY_MATRIX' }), buttons: (react_1.default.createElement(react_1.default.Fragment, null, isReEnrichmentInProgress && react_1.default.createElement(generic_1.ReEnrichButton, { loading: true, disabled: true }, t({ key: 'RE_ENRICH_CATEGORY_ACTION_IN_PROGRESS_TITLE' })), react_1.default.createElement(react_router_dom_1.Link, { to: `/${router_1.ENRICH}/${router_1.EnrichSection.EnrichAI}/${router_1.EnrichSection.Workspace}` }, react_1.default.createElement(ui_components_1.Button, { variant: "outlined", rounded: true }, t({ key: 'BACK_TO_WORKSPACE' }))))) }), selectedCatalogId && (areMatrixPrerequisitesLoading ? (react_1.default.createElement(strategy_matrix_skeleton_1.StrategyMatrixSkeleton, null)) : (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(table_styles_1.SelectorsWrapper, null, react_1.default.createElement(l1_category_matrix_selector_component_1.L1CategorySelect, { selectedCatalogId: selectedCatalogId, selectedProductTreeId: selectedProductTreeId, productTreeRootNodeId: productTreeRootNodeId, selectedCategories: sortedSelectedL1Categories, onSelect: handleCategorySelectionChanged }), react_1.default.createElement(attributes_matrix_selector_container_1.AttributeSelect, { productTreeRootNodeId: productTreeRootNodeId, selectedAttributes: selectedAttributes, onSelect: handleAttributesSelectionChanged }), react_1.default.createElement(display_table_select_component_1.DisplayTableSelect, { selectedOptions: selectedDisplayTable, onSelect: handleDisplayTableSelectionChanged })), react_1.default.createElement(matrix_table_component_1.MatrixTable, { selectedCatalogId: selectedCatalogId, selectedProductTreeId: selectedProductTreeId, selectedStrategyNodeId: productTreeRootNodeId, selectedAttributes: selectedAttributes, selectedL1Categories: sortedSelectedL1Categories, selectedDisplayTable: selectedDisplayTable, categoriesIsLoading: false }))))));
};
exports.StrategyMatrix = StrategyMatrix;
exports.default = exports.StrategyMatrix;
